export default "__VITE_ASSET__75429c4d__"